<template>
  <main class="upgrade-page">
    <header class="upgrade-header">
      <div class="upgrade-header-glow"></div>
      <h1>套餐升级</h1>
    </header>

    <section class="upgrade-card" v-for="(item,index) in packagelist" :key="item.newPackageID || index">
      <div class="price-row">
        <label class="select-wrap" aria-label="选择升级套餐">
          <input class="select-radio" type="radio" name="upgrade-plan" :checked="checked===index" @change="checked=index">
          <span class="select-dot" aria-hidden="true"></span>
        </label>
        <div class="price-col"><p class="price-main">{{ nowPackage.price }}</p><p class="price-sub">{{ nowPackage.title }}</p></div>
        <img class="arrow-icon" src="./static/images/package-upgrade/jiantou.png" alt="" aria-hidden="true">
        <div class="price-col"><p class="price-main">{{ item.price }}</p><p class="price-sub">{{ item.title }}</p></div>
        <div class="price-col price-col--cta"><p class="price-main price-main--red">{{ item.diff }}</p><button type="button" class="buy-btn" @click="submit(item)">升级购买</button></div>
      </div>
    </section>

    <section class="tips">
      <h2>温馨提示</h2>
      <ol>
        <li>网络服务由当地优质运营商提供，安全靠谱。</li>
        <li>购买后30天之内随时启用，有效期将从启用后开始计算，每24小时计为1天，一经启用，无法暂停计时。</li>
        <li>购买后使用30天以内，可在公众号联系客服取消订单；在海岛、隧道、山区、高速公路、沙漠等偏远地区，可能会出现信号较弱和信号丢失。</li>
        <li>开启热点共享时，建议关闭接入手机的同步、备份等功能，避免套餐流量消耗过快。</li>
      </ol>
    </section>
  </main>
</template>

<script>
export default {
  name: "shengjiNew",
  data () { return { checked: null, iccid: "", operator: {}, packagelist: [], nowPackage: {}, arr: [] } },
  methods: {
    getPackagelist () {
      this.fetchData("/package/shengji", { iccid: this.iccid }, (res) => {
        this.packagelist = (res.data && res.data.list) || []
        this.arr = (res.data && res.data.arr) || []
        this.nowPackage = (res.data && res.data.nowpackage) || {}
      })
    },
    submit (item) {
      this.$toast.loading({ duration: 0, forbidClick: true, message: "正在下单" })
      const postData = { packageID: this.nowPackage.id, target: item.target, price: item.diff, iccid: this.iccid, newPackageID: item.newPackageID }
      this.fetchData("/order/shengji", postData, (res) => {
        this.$toast.clear()
        if (res.code) {
          window.WeixinJSBridge.invoke("getBrandWCPayRequest", res.data, (payRes) => {
            if (payRes.err_msg === "get_brand_wcpay_request:ok") {
              this.$toast("支付成功")
              this.$router.push({ name: "index", query: { iccid: this.iccid } })
            }
          })
        } else if (res.url) {
          this.$dialog.confirm({ title: "提示", message: res.msg }).then(() => { window.location.href = res.url })
        } else {
          this.$toast(res.msg)
        }
      })
    }
  },
  created () {
    this.iccid = this.$route.query.iccid
    this.fetchData("/card/cardoperator", { iccid: this.iccid }, (res) => { this.operator = res.data || {} })
    this.getPackagelist()
  }
}
</script>

<style scoped src="./static/css/package-upgrade.css"></style>



// WEBPACK FOOTER //
// src/newpage/shengji.vue